import React from 'react';
import PropTypes from 'prop-types';

function FeedbackError({ errors, touched, name }) {
  return errors[name] && touched[name] ? <div className="input-feedback">{errors[name]}</div> : '';
}

FeedbackError.propTypes = {
  name: PropTypes.string.isRequired,
  errors: PropTypes.shape({
    name: PropTypes.bool.isRequired,
  }).isRequired,
  touched: PropTypes.shape({
    name: PropTypes.bool.isRequired,
  }).isRequired,
};

export default FeedbackError;
